module.exports = __webpack_public_path__ + "static/media/rescuers.67478548.jpg";